import { Set } from 'immutable';

import { EBAY, ETSY, FAIRE, SHOPIFY } from '@/constants/channels';
import { STATUS } from '@/constants/listings';
import { VELA } from '.';

export const STATUS_COLUMN = {
  ACTIVE: 'Active',
  ARCHIVED: 'Archived',
  DRAFT: 'Draft',
  COPIED: 'Copied',
  IMPORTED: 'Imported',
  INACTIVE: 'Inactive',
  PUBLISHED: 'Published',
  UNPUBLISHED: 'Unpublished',
  STAGING: 'Staging',
};

export const STATUS_COLUMN_ORDER = {
  [STATUS_COLUMN.STAGING]: 0,
  [STATUS_COLUMN.COPIED]: 1,
  [STATUS_COLUMN.INACTIVE]: 2,
  [STATUS_COLUMN.ARCHIVED]: 3,
  [STATUS_COLUMN.UNPUBLISHED]: 4,
  [STATUS_COLUMN.IMPORTED]: 5,
  [STATUS_COLUMN.DRAFT]: 6,
  [STATUS_COLUMN.ACTIVE]: 7,
  [STATUS_COLUMN.PUBLISHED]: 8,

};

export const STATUS_COLUMNS = {
  ACTIVE: Set([STATUS_COLUMN.ACTIVE]),
  ACTIVE_ARCHIVED_DRAFT: Set([STATUS_COLUMN.ARCHIVED, STATUS_COLUMN.DRAFT, STATUS_COLUMN.ACTIVE]),
  ACTIVE_COPIED: Set([STATUS_COLUMN.COPIED, STATUS_COLUMN.ACTIVE]),
  ACTIVE_COPIED_DRAFT: Set([STATUS_COLUMN.COPIED, STATUS_COLUMN.DRAFT, STATUS_COLUMN.ACTIVE]),
  ACTIVE_STAGING: Set([STATUS_COLUMN.ACTIVE, STATUS_COLUMN.STAGING]),
  ACTIVE_DRAFT_STAGING: Set([STATUS_COLUMN.ACTIVE, STATUS_COLUMN.DRAFT, STATUS_COLUMN.STAGING]),

  ACTIVE_DRAFT: Set([STATUS_COLUMN.DRAFT, STATUS_COLUMN.ACTIVE]),
  ACTIVE_DRAFT_IMPORTED: Set([STATUS_COLUMN.IMPORTED, STATUS_COLUMN.DRAFT, STATUS_COLUMN.ACTIVE]),
  ACTIVE_INACTIVE: Set([STATUS_COLUMN.INACTIVE, STATUS_COLUMN.ACTIVE]),
  ACTIVE_IMPORTED: Set([STATUS_COLUMN.IMPORTED, STATUS_COLUMN.ACTIVE]),

  PUBLISHED_DRAFT: Set([STATUS_COLUMN.DRAFT, STATUS_COLUMN.PUBLISHED]),
  PUBLISHED_DRAFT_COPIED: Set([STATUS_COLUMN.COPIED, STATUS_COLUMN.DRAFT, STATUS_COLUMN.PUBLISHED]),
  PUBLISHED_DRAFT_STAGING: Set([STATUS_COLUMN.DRAFT, STATUS_COLUMN.PUBLISHED, STATUS_COLUMN.STAGING]),
  PUBLISHED_DRAFT_IMPORTED: Set([STATUS_COLUMN.IMPORTED, STATUS_COLUMN.DRAFT, STATUS_COLUMN.PUBLISHED]),
  PUBLISHED_DRAFT_UNPUBLISHED: Set([STATUS_COLUMN.UNPUBLISHED, STATUS_COLUMN.DRAFT, STATUS_COLUMN.PUBLISHED]),
};

export const COLUMN_STATUS_MAP = {
  [EBAY]: {
    [STATUS_COLUMN.ACTIVE]: STATUS[EBAY].ACTIVE,
    [STATUS_COLUMN.COPIED]: STATUS[VELA].COPIED,
    [STATUS_COLUMN.IMPORTED]: STATUS[VELA].UNPUBLISHED,
    [STATUS_COLUMN.STAGING]: STATUS[VELA].STAGING,
  },
  [ETSY]: {
    [STATUS_COLUMN.ACTIVE]: STATUS[ETSY].ACTIVE,
    [STATUS_COLUMN.DRAFT]: STATUS[ETSY].DRAFT,
    [STATUS_COLUMN.COPIED]: STATUS[VELA].COPIED,
    [STATUS_COLUMN.IMPORTED]: STATUS[VELA].UNPUBLISHED,
    [STATUS_COLUMN.INACTIVE]: STATUS[ETSY].INACTIVE,
    [STATUS_COLUMN.STAGING]: STATUS[VELA].STAGING,
  },
  [FAIRE]: {
    [STATUS_COLUMN.DRAFT]: STATUS[FAIRE].DRAFT,
    [STATUS_COLUMN.COPIED]: STATUS[VELA].COPIED,
    [STATUS_COLUMN.IMPORTED]: STATUS[VELA].UNPUBLISHED,
    [STATUS_COLUMN.PUBLISHED]: STATUS[FAIRE].PUBLISHED,
    [STATUS_COLUMN.UNPUBLISHED]: STATUS[FAIRE].UNPUBLISHED,
    [STATUS_COLUMN.STAGING]: STATUS[VELA].STAGING,
  },
  [SHOPIFY]: {
    [STATUS_COLUMN.ACTIVE]: STATUS[SHOPIFY].ACTIVE,
    [STATUS_COLUMN.ARCHIVED]: STATUS[SHOPIFY].ARCHIVED,
    [STATUS_COLUMN.DRAFT]: STATUS[SHOPIFY].DRAFT,
    [STATUS_COLUMN.COPIED]: STATUS[VELA].COPIED,
    [STATUS_COLUMN.IMPORTED]: STATUS[VELA].UNPUBLISHED,
    [STATUS_COLUMN.STAGING]: STATUS[VELA].STAGING,
  },
};

export const STATUS_COLUMN_MAP = {
  [EBAY]: {
    [STATUS[EBAY].ACTIVE]: STATUS_COLUMN.ACTIVE,
    [STATUS[VELA].COPIED]: STATUS_COLUMN.COPIED,
    [STATUS[VELA].IMPORTED]: STATUS_COLUMN.IMPORTED,
    [STATUS[VELA].UNPUBLISHED]: STATUS_COLUMN.IMPORTED,
    [STATUS[VELA].STAGING]: STATUS_COLUMN.STAGING,
  },
  [ETSY]: {
    [STATUS[ETSY].ACTIVE]: STATUS_COLUMN.ACTIVE,
    [STATUS[ETSY].DRAFT]: STATUS_COLUMN.DRAFT,
    [STATUS[ETSY].INACTIVE]: STATUS_COLUMN.INACTIVE,
    [STATUS[VELA].COPIED]: STATUS_COLUMN.COPIED,
    [STATUS[VELA].IMPORTED]: STATUS_COLUMN.IMPORTED,
    [STATUS[VELA].UNPUBLISHED]: STATUS_COLUMN.IMPORTED,
    [STATUS[VELA].STAGING]: STATUS_COLUMN.STAGING,
  },
  [FAIRE]: {
    [STATUS[FAIRE].PUBLISHED]: STATUS_COLUMN.PUBLISHED,
    [STATUS[FAIRE].DRAFT]: STATUS_COLUMN.DRAFT,
    [STATUS[FAIRE].UNPUBLISHED]: STATUS_COLUMN.UNPUBLISHED,
    [STATUS[VELA].COPIED]: STATUS_COLUMN.COPIED,
    [STATUS[VELA].IMPORTED]: STATUS_COLUMN.IMPORTED,
    [STATUS[VELA].UNPUBLISHED]: STATUS_COLUMN.IMPORTED,
    [STATUS[VELA].STAGING]: STATUS_COLUMN.STAGING,
  },
  [SHOPIFY]: {
    [STATUS[SHOPIFY].ACTIVE]: STATUS_COLUMN.ACTIVE,
    [STATUS[SHOPIFY].ARCHIVED]: STATUS_COLUMN.ARCHIVED,
    [STATUS[SHOPIFY].DRAFT]: STATUS_COLUMN.DRAFT,
    [STATUS[VELA].COPIED]: STATUS_COLUMN.COPIED,
    [STATUS[VELA].IMPORTED]: STATUS_COLUMN.IMPORTED,
    [STATUS[VELA].UNPUBLISHED]: STATUS_COLUMN.IMPORTED,
    [STATUS[VELA].STAGING]: STATUS_COLUMN.STAGING,
  },
};
